import { createBrowserRouter, Outlet } from 'react-router-dom';
import { PageShell } from '../layouts';
import { createFeatureRoutes, createAdminRoutes } from './routes';
import type { CompositionRoot } from './composition-root';

/**
 * Router factory. Built from the Composition Root (rather than as a static
 * module-level export) so feature route loaders can use the already-resolved
 * use cases. `<Outlet />` renders whichever child route matched inside the
 * shared PageShell (Header/Footer) — previously this was hardcoded to `null`
 * before any real feature route existed to render into it.
 *
 * Admin routes are a second, sibling top-level branch (not nested under the
 * `/` PageShell route) because the admin panel has its own AdminLayout
 * header/nav and must never render the public site Header/Footer.
 */
export function createRouter(compositionRoot: CompositionRoot) {
  return createBrowserRouter([
    {
      path: '/',
      element: (
        <PageShell>
          <Outlet />
        </PageShell>
      ),
      children: createFeatureRoutes(compositionRoot)
    },
    ...createAdminRoutes(compositionRoot)
  ]);
}
